import React, { useEffect, useState } from "react";
import {
  setchatid,
  setchatdata,
  setshowExternalChat,
  endInteraction,
  setcontactlist,
  setVoiceRefresh,
  setShowingStatus,
  setShowingStatusClass,
  setReadyButton,
  setShowingStatusVoice,
} from "../../../../redux/actions/actions";
import { connect } from "react-redux";
import axios from "axios";
import { BaseUrl, emailservice } from "../../../../container/BaseUrl/BaseUrl";
import { toast } from "react-toastify";
import {
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

const mapStateToProps = (state) => {
  console.log("ssssssssssssssssssssssss", state);
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
    externalChatData: state.data.externalChatData,
    readyButton: state.contactListData.readyButton,
    showingStatus: state.contactListData.showingStatus,
    showingStatusClass: state.contactListData.showingStatusClass,
    showingStatusVoice: state.contactListData.showingStatusVoice,
  };
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const EndchatModel = (props) => {
  const AvcUrl = localStorage.getItem("AvcUrl");
  const { chat, OpenDialog, handleClose, value } = props;
  const [reasonerror, setreasonerror] = useState(false);
  const [commentserror, setcommentserror] = useState(false);
  const [comments, setComments] = useState("");
  const [reason, setReason] = useState("");
  const [checkvalue, setCheckvalue] = useState(false);
  const [dispositionlist, setdispositionlist] = useState([]);

  const endChat = () => {
    if (reason === "") {
      setreasonerror(true);
    } else {
      let userId = JSON.parse(localStorage.getItem("tokenAgent"));
      let agentId = userId.id;
      let data = {
        chat_session_id: chat.chat_session_id,
        chatendby: "Agent",
        reason: reason,
        comment: comments || "",
        agent_id: agentId,
        ticket: checkvalue ? checkvalue : "",
      };

      if (props.externalChatData.channel === "voice") {
        if (
          localStorage.getItem("type") === "sales" ||
          localStorage.getItem("type") === "service"
        ) {
          data = {
            chat_session_id: chat.chat_session_id,
            chatendby: "Agent",
            reason: reason,
            comment: comments || "",
            agent_id: agentId,
            contact_id: localStorage.getItem("ContactVoiceId"),
            voice_type: "contact_voice",
            contact_type: localStorage.getItem("type"),
          };
        }
        end_call()
      }
      axios
        .post(BaseUrl + "/message/endchat", data, {
          headers: {
            tenantId: localStorage.getItem("TenantId"),
          },
        })
        .then(async (res) => {
          if (res.data.success == true) {
            if (props.externalChatData.channel === "voice") {
              updateStatus("Ready");
            }
            if (localStorage.getItem("misserCallClicktoCall")) {
              completed();
            }
            if (localStorage.getItem("CampaignCallClicktoCall")) {
              completedCampaign();
            }
            localStorage.removeItem("client");
            props.setshowExternalChat(false);
            props.endInteraction();
            handleClose();
            toast.success("Interaction Ended Successfully", {
              position: "top-right",
              autoClose: 500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
            });
            localStorage.removeItem("callActivate");
            localStorage.removeItem("type");
            localStorage.removeItem("ContactVoiceId");
            localStorage.removeItem("Contactreg_no");
            EndChatClearCache();
            handleClose();
          }
        })
        .catch((error) => {});
    }
  };


  const end_call = async () => {
    let contactId = localStorage.getItem("contactId");
    let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
    await axios
      .post(
        AvcUrl +
          `/voice/terminal/${agentLoginTerminalId}/disconnect/` +
          contactId,
        {},
        {
          headers: {
            ssoToken: localStorage.getItem("ssoToken"),
          },
        }
      )
      .then((res) => {
        console.log("end_call", res);
        localStorage.removeItem("contactId");
      })
      .catch((err) => {
        console.error(err);
        localStorage.removeItem("contactId");
 
      });
  };

  const closeTicketApi = async (value) => {
    let sessionId = JSON.parse(localStorage.getItem("client"));

    let dataToPass = {
      ticketID: sessionId.ticketID,
      ticketStatus: checkvalue,
    };

    axios
      .post(emailservice + "email/endMailStatusUpdate", dataToPass, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((response) => {
        if (response.data.status) {
        }
      })
      .catch((err) => {});
  };

  const Dispositionlist = async () => {
    axios
      .post(
        BaseUrl + "/userstatus/dispositionlist",
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setdispositionlist(res.data.data);
        } else {
          setdispositionlist([]);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    Dispositionlist();
    if (dispositionlist.length > 0) {
      setReason(
        dispositionlist[0].dispositionName || dispositionlist.dispositionName
      );
    }
  }, []);

  const EndChatClearCache = () => {
    setComments("");
    setCheckvalue("");
  };

  const updateStatus = async (value) => {
    if (!value) return;
    let data = await JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/updateAgentStatus/",
        {
          status: value,
          userId: data.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          props.setReadyButton(true);
          props.setShowingStatus(value);
          localStorage.setItem("AgentStatus", value);
          props.setShowingStatusClass("showStatus");
          if (props.showingStatusVoice == "Not Connected") {
          } else {
            changeStatusVoice("Ready", "Ready");
          }
        } else {
        }
      })
      .catch((err) => {});
  };
  const changeStatusVoice = async (status, value2) => {
    if (localStorage.getItem("voiceEnable") == "true") {
      await axios
        .post(
          AvcUrl +
            `/voice/cct/agent/${localStorage.getItem(
              "agentLoginTerminalId"
            )}/status?status=${status}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken")
                ? localStorage.getItem("ssoToken")
                : "",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            props.setShowingStatusVoice(value2);
            if (status == "Ready") {
              localStorage.removeItem("VoiceActivate");
            }
          } else {
            props.setShowingStatusVoice("Not Connected");
          }
        })
        .catch((error) => {
          props.setShowingStatusVoice("Not Connected");
        });
    }
  };

  const completed = async (value) => {
    await axios
      .post(
        BaseUrl + "/contact/updatecampaignDetails",
        {
          contactid: localStorage.getItem("misserCallClicktoCall"),
          status: reason,
          chat_session_id: chat.chat_session_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        localStorage.removeItem("misserCallClicktoCall");
      })
      .catch((err) => {});
  };
  const completedCampaign = async (value) => {
    await axios
      .post(
        BaseUrl + "/contact/updatecampaign",
        {
          contactid: localStorage.getItem("CampaignCallClicktoCall"),
          status: reason,
          chat_session_id: chat.chat_session_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        localStorage.removeItem("CampaignCallClicktoCall");
      })
      .catch((err) => {});
  };

  return (
    <>
      <Dialog
        open={OpenDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          handleClose();
          setComments("");
          setCheckvalue("");
        }}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiPaper-root": {
            borderRadius: 5,
            padding: 1,
            top: -100,
          },

          backgroundColor: "rgb(0 0 0 / 65%)",
        }}
      >
        <DialogTitle
          variant="subtitle2"
          sx={{ fontSize: "16px", fontWeight: 600 }}
        >
          End Interaction
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Stack spacing={1}>
              <Stack direction={"row"}>
                <select
                  className={`form-select ${reasonerror ? "is-invalid" : ""}`}
                  aria-label="Default select example"
                  onChange={(e) => setReason(e.target.value)}
                >
                  <option>Select Reason *</option>
                  {dispositionlist.map((item) => (
                    <option value={item.dispositionName}>
                      {item.dispositionName}
                    </option>
                  ))}
                </select>
              </Stack>
              {reasonerror ? (
                <span className="text-danger">Choose a reason*</span>
              ) : (
                ""
              )}
              <input
                className={"form-control"}
                onChange={(e) => setComments(e.target.value)}
                placeholder="Enter Comments..."
                id="floatingTextarea2"
                style={{ height: "100px", width: "350px" }}
              ></input>

              {props.externalChatData.channel === "email" ? (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkvalue}
                      onChange={(e) => setCheckvalue(e.target.checked)}
                    />
                  }
                  label="Close Ticket"
                />
              ) : (
                ""
              )}
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (reason == "") {
                setreasonerror(true);
                // setcommentserror(false);
              } else if (props.externalChatData.channel == "email") {
                EndChatClearCache();
                closeTicketApi();
                endChat();
                handleClose();
              } else {
                EndChatClearCache();
                endChat();
                handleClose();
              }
            }}
            variant="contained"
            size="small"
            id="submit-btn"
          >
            SUBMIT
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect(mapStateToProps, {
  setchatid,
  setchatdata,
  setshowExternalChat,
  endInteraction,
  setcontactlist,
  setVoiceRefresh,
  setShowingStatus,
  setShowingStatusClass,
  setReadyButton,
  setShowingStatusVoice,
})(EndchatModel);
